import React from "react";
import { Grid2 as Grid, Typography } from "@mui/material";

const HeaderField = ({
  label,
  value,
  color = "inherit",
  highlight = false,
  xs = 12,
  sm = 3,
  md = 3,
}) => (
  <Grid size={{ xs: xs, sm: sm }} md={md}>
    <Typography variant="body2" fontWeight={600}>
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={
        highlight
          ? {
              color,
              fontWeight: "bold",
              border: `1px solid ${color}`,
              px: 1,
              borderRadius: 0.5,
            }
          : {}
      }
    >
      {value || "N/A"}
    </Typography>
  </Grid>
);

export default HeaderField;
